import {IS_GOOGLE_CONNECTED} from '@/store/getter.types'
import {SET_GMB_DATA} from '../mutation.types'

/**
 * Whether want to namespace it ot not
 * @type {boolean}
 * @author Vvikas gupta
 */
export const namespaced = true

/**
 * State related to GMB
 * @type {Object}
 * @author Vvikas gupta
 */
export const state = {
  gmbSetup: {},
  key: 0
}

/**
 * Getter related to GMB
 * @type {Object}
 * @author Vvikas gupta
 */
export const getters = {
  [IS_GOOGLE_CONNECTED]: state => {
    return (state.key > -1 && 'data' in state.gmbSetup) && state.gmbSetup.data
  }
}

/**
 * Mutations related to GMB
 * @type {Object}
 * @author Vvikas gupta
 */
export const mutations = {
  /**
   * Set the GMB data
   * @param {object} state - Stat object
   * @param {object} payload - Payload object
   * @return {void}
   * @author Vvikas gupta
   */
  [SET_GMB_DATA] (state, payload) {
    state.gmbSetup = payload
    ++state.key
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/gmb.js